import React, { useContext } from 'react';
import spinner from '../../assets/img/ui/indicators/ajax-loader-processing-24.gif';
import '../../assets/css/Loader.css';

import LoadingContext from '../layout/search/loading-context';

interface Props {
    alwaysActive: boolean;
}

const LoaderNew = (props: Props) => {
    const loadingCtx = useContext(LoadingContext);

    return (
        <>
            {(props.alwaysActive || loadingCtx.isLoading) && (
                <div className='loader-container'>
                    <img className='loader-img' src={spinner} />
                </div>
            )}
        </>
    );
};

export default LoaderNew;
